import axios, { AxiosRequestHeaders } from "axios";
import { decodeAuthToken } from "../components/utils";
import { useAuthStore } from "../store";
import { attachAuthRefresh } from "./authRefresh";

const hissaApi = axios.create({
  baseURL:
    sessionStorage.getItem("apiUrl") ||
    process.env.REACT_APP_API ||
    "http://localhost:8080",
});
hissaApi.defaults.headers.post["Content-Type"] = "application/json";
hissaApi.interceptors.request.use((config) => {
  const accesstoken = useAuthStore.getState().accessToken;
  // eslint-disable-next-line etc/no-commented-out-code
  // revalidateAuth();
  if (accesstoken && !config.url?.endsWith("/login")) {
    (config.headers as AxiosRequestHeaders).companyId =
      sessionStorage.getItem("companyId") ?? "";
    (config.headers as AxiosRequestHeaders).AccessToken = accesstoken;
  }
  // use X-USR-TOKEN for logout only
  if (config.url === "exit") {
    (config.headers as AxiosRequestHeaders)["x-user-token"] = decodeAuthToken(
      accesstoken ?? ""
    ).xUserToken;
    delete (config.headers as AxiosRequestHeaders).AccessToken;
  }
  return config;
});
attachAuthRefresh(hissaApi, "AccessToken");

export default hissaApi;
